import Grid from "@mui/material/Grid";

import { FlexGrid } from "../../common/grid/components/FlexGrid";
import {
  BenefitImage,
  BenefitText,
  BenefitTitle,
} from "../styles/ProductStyles";
import type { ProductFeature } from "../types/productTypes";

type ProductFeatureCardProps = {
  benefit: ProductFeature;
};

export const ProductFeatureCard = ({ benefit }: ProductFeatureCardProps) => {
  return (
    <Grid container>
      <FlexGrid size={{ xs: 2 }}>
        <BenefitImage src={benefit.icon} alt={benefit.title} />
      </FlexGrid>

      <Grid size={{ xs: 10 }}>
        <BenefitTitle>{benefit.title}</BenefitTitle>

        {benefit.specialText?.length ? (
          benefit.specialText.map((text) => (
            <Grid
              container
              sx={{ marginBottom: "10px" }}
              key={`special_mbenefits_${text[0]}`}
            >
              <Grid size={{ xs: 12 }}>
                <BenefitText>{text[0]}</BenefitText>
              </Grid>
            </Grid>
          ))
        ) : (
          <BenefitText>{benefit.text}</BenefitText>
        )}
      </Grid>
    </Grid>
  );
};